import { CardToolsGroup, CardToolsProviderService } from '@addins/core/singlecallcard';
import { AddAttachmentToolsControllerService } from '@addins/singlecallcard-attachments';
import { JournalToolsControllerService } from '@addins/singlecallcard-journal';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Task } from '@models/imported/SagaSchema/Task';
import { Subscription } from 'rxjs';
import { CurrentTaskService } from '../../services/current-task/current-task.service';
import { TasksProviderService } from '../../services/tasks-provider/tasks-provider.service';

@Component({
  selector: 'app-task-add-item-button',
  templateUrl: './task-add-item-button.component.html',
  styleUrls: ['./task-add-item-button.component.scss']
})
export class TaskAddItemButton implements OnInit, OnDestroy {
  @Input()
  task: Task;

  private tasksChangedSub: Subscription;
  private currentTaskChangedSub: Subscription;
  private addAttachmentToolsGroupAdded: boolean = false;
  private addStampToolsGroupAdded: boolean = false;

  constructor(
    protected cardToolsProvider: CardToolsProviderService,
    private tasksProvider: TasksProviderService,
    private currentTask: CurrentTaskService,
    private addAttachmentTools: AddAttachmentToolsControllerService,
    private journalToolsController: JournalToolsControllerService
  ) {}

  ngOnInit() {
    if (this.addAttachmentTools.fromMyCallcardOnly || this.journalToolsController.fromMyCallcardOnly) {
      this.tasksChangedSub = this.tasksProvider.tasks.onRefresh.subscribe(() => this.onTaskChanged());
      this.currentTaskChangedSub = this.currentTask.$change.subscribe(() => this.onTaskChanged());
    }
  }

  private onTaskChanged() {
    if (this.addAttachmentTools.fromMyCallcardOnly) {
      this.addAttachmentToolsGroupAdded = this.handleToolsGroupForMyCardOnly(
        this.addAttachmentTools.addAttachmentToolsGroup,
        this.addAttachmentToolsGroupAdded
      );
    }

    if (this.journalToolsController.fromMyCallcardOnly) {
      this.addStampToolsGroupAdded = this.handleToolsGroupForMyCardOnly(
        this.journalToolsController.addStampToolsGroup,
        this.addStampToolsGroupAdded
      );
    }
  }

  private handleToolsGroupForMyCardOnly(cardToolsGroup: CardToolsGroup, groupWasAdded: boolean): boolean {
    if (this.isMyTaskShown()) {
      if (this.cardToolsProvider.cardToolGroups.indexOf(cardToolsGroup) == -1) {
        this.cardToolsProvider.addCardToolsGroup(cardToolsGroup);
        groupWasAdded = true;
      }
    } else if (groupWasAdded) {
      this.cardToolsProvider.removeCardToolsGroup(cardToolsGroup);
      groupWasAdded = false;
    }

    return groupWasAdded;
  }

  private isMyTaskShown(): boolean {
    return this.currentTask.current && this.tasksProvider.myTask && this.tasksProvider.myTask.ObjGuid == this.currentTask.current.ObjGuid;
  }

  ngOnDestroy() {
    if (this.addAttachmentTools.fromMyCallcardOnly || this.journalToolsController.fromMyCallcardOnly) {
      this.currentTaskChangedSub?.unsubscribe();
      this.tasksChangedSub?.unsubscribe();

      if (this.addAttachmentToolsGroupAdded) {
        this.cardToolsProvider.removeCardToolsGroup(this.addAttachmentTools.addAttachmentToolsGroup);
      }
      if (this.addStampToolsGroupAdded) {
        this.cardToolsProvider.removeCardToolsGroup(this.journalToolsController.addStampToolsGroup);
      }
    }
  }

  onCardToolsClicked() {
    this.cardToolsProvider.showTools(this.task.ObjGuid);
  }
}
